import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { Page } from '../'
import * as api from '../../lib/api'
import Loading from '../../components/loading'
import { NavInSites } from '../../components/nav'
import { apiCache } from '../../stores'

export const Bundles = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [bundles, setBundles] = useState(apiCache.bundles.list() || [])
  const [hovered, setHovered] = useState(undefined)

  useEffect(() => {
    api.bundles.list().then(bundles => {
      setBundles(bundles || [])
      setIsLoading(false)
    })
  }, [])

  return (
    <Page>
      <NavInSites />
      <div id="content">
        {isLoading ? (
          <Loading />
        ) : (
          <>
            {bundles.length === 0 ? (
              <p>Rien à afficher</p>
            ) : (
              <div style={{ marginBottom: 50 }}>
                <div style={{ ...styles.row, ...styles.header }}>
                  <span>Nom</span>
                  <span>Description</span>
                  <span />
                </div>
                {bundles.map((bundle, index) => (
                  <Link
                    key={bundle._id}
                    to={'/bundle/' + bundle._id}
                    onMouseEnter={() => setHovered(bundle._id)}
                    onMouseLeave={() => setHovered(undefined)}
                    style={{
                      ...styles.row,
                      ...styles.bundle,
                      backgroundColor: hovered === bundle._id ? '#f0f8ff' : index % 2 ? '#f9f9f9' : undefined
                    }}
                  >
                    <span>{bundle.name}</span>
                    <span>{bundle.description}</span>
                    <span style={{ textAlign: 'right' }} title="modifier">
                      <i className="fa fa-edit" />
                    </span>
                  </Link>
                ))}
              </div>
            )}
            <div style={{ position: 'fixed', bottom: 5, right: 5 }}>
              <Link to="/bundle/" className="btn btn-primary btn-block">
                Ajouter un groupe
              </Link>
            </div>
          </>
        )}
      </div>
    </Page>
  )
}

// Chaque bundle est UN lien qui occupe la ligne entière : un tableau obligerait à découper la zone
// cliquable en cellules, dont le clic sélectionne le contenu au lieu de la ligne.
const styles = {
  row: { display: 'grid', gridTemplateColumns: '1fr 2fr 40px', gap: 10, padding: 8, alignItems: 'center' },
  header: { fontWeight: 'bold', borderBottom: '2px solid #ddd' },
  bundle: { color: 'inherit', textDecoration: 'none', borderTop: '1px solid #ddd' }
}
